module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Regular-2cfeeb478bece9695faaf853a7018955.otf";